import { render } from "./StarRatingInput.vue?vue&type=template&id=09bfa18b"
import script from "./StarRatingInput.vue?vue&type=script&lang=js"
export * from "./StarRatingInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__